import moment from "moment";
import { IFiltersReducerState, ITimeFilter, TIME_RANGE_OPTIONS_E } from "../../types";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TIME_FILTER_FORMAT } from "../../utils/constants";

const initialState: IFiltersReducerState = {
	timeRange: TIME_RANGE_OPTIONS_E.TODAY,
	timeFilter: {
		start_time: moment().startOf("day").format(TIME_FILTER_FORMAT),
		end_time: moment().endOf("day").format(TIME_FILTER_FORMAT)
	}
};

const filtersReducer = createSlice({
	name: "filters",
	initialState: initialState,
	reducers: {
		setTimeFilter: (state, { payload }: PayloadAction<ITimeFilter>) => {
			state.timeFilter = payload;
		},

		setTimeRange: (state, { payload }: PayloadAction<TIME_RANGE_OPTIONS_E>) => {
			state.timeRange = payload;
		},

		resetAllFilters: (state) => {
			state.timeRange = initialState.timeRange;
			state.timeFilter = initialState.timeFilter;
		}
	}
});

export const { setTimeFilter, setTimeRange, resetAllFilters } = filtersReducer.actions;

export default filtersReducer;
